import React from 'react';

const VisaCardIcon = ({size = 24}) => (
  <svg width={size} height={size} role="presentation" fill="none" viewBox="0 0 20 20">
    <path fill="#21246E"
          d="M20 18.82c0 .66-.34 1.18-.74 1.18H.74c-.4 0-.74-.52-.74-1.18V1.18C0 .52.34 0 .74 0h18.51c.41 0 .74.52.74 1.18L20 18.82Z"
    />
    <path fill="#fff"
          d="m7.28 7.6-2.22 5.26H3.6l-1.1-4.2c-.06-.26-.13-.35-.33-.46a6.32 6.32 0 0 0-1.35-.45l.03-.15H3.2c.3 0 .56.2.63.54l.58 3.05L5.85 7.6h1.43Zm5.7 3.54c0-1.39-1.95-1.46-1.93-2.09 0-.19.18-.39.58-.44.2-.02.74-.05 1.35.24l.24-1.11a3.53 3.53 0 0 0-1.29-.24c-1.36 0-2.3.71-2.32 1.74-.01.76.69 1.17 1.2 1.44.54.26.71.42.71.64 0 .36-.42.52-.82.52-.7.01-1.1-.19-1.42-.34l-.25 1.15a4 4 0 0 0 1.53.28c1.46 0 2.41-.7 2.41-1.8Zm3.58 1.72h1.27l-1.1-5.26h-1.18a.63.63 0 0 0-.6.39l-2.05 4.87h1.43l.3-.79h1.75l.18.8ZM15.02 11 15.75 9l.4 1.98h-1.13ZM9.25 7.6 8.1 12.86H6.73L7.87 7.6h1.38Z"
    />
  </svg>
);

export default VisaCardIcon;
